import { render, staticRenderFns } from "./side-menu-unit.vue?vue&type=template&id=2e294a5c&lang=pug&"
import script from "./side-menu-unit.vue?vue&type=script&lang=js&"
export * from "./side-menu-unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports